// import {
//   Button,
//   Chip,
//   Divider,
//   Grid,
//   Paper,
//   Stack,
//   Typography,
// } from "@mui/material";
// import React, { useEffect, useState } from "react";
// import { WSIcons } from "../../../commonFunctions/iIcons";
// import WSDataGridNew, {
//   IColumns,
// } from "../../../Components/DataGrid/WSDataGridNew";
// import WSImageUpload from "../../../Components/FileUpload/WSImageUpload";
// import { useForm } from "react-hook-form";
// import WSButton from "../../../Components/Button/WSButton";
// import LiveDeliveryMap from "../../../Components/MapView/MapView";
// import LiveLocation from "../../../Components/MapView/MapView";
// import LiveLocationMap from "../../../Components/MapView/MapView";
// import LiveLocationTracker from "../../../Components/MapView/MapView";
// import SwipeableDrawerForm from "../../../Components/DrawyerForm/DrawyerForm";
// import AssignOrderDrawer from "./AssignDrawer";
// import WSBackButton from "../../../Components/BackButton/BackButton";
// import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
// import { useParams } from "react-router-dom";

// export const TechnicianDetails: React.FC<any> = React.memo((props) => {
//   const { control, setValue, reset, register, handleSubmit } = useForm();
//   const [open, setOpen] = React.useState(false);
//   const [formComponent, setFormComponent] = useState<any>();

//   const params = useParams();
//   const id = params?.id;
//   useEffect(() => {
//     breadCrumbsStore.updateBreadCrumbs([
//       { "Technician Management": "technician-management/list" },
//       {
//         [!id ? "Technician Details" : ""]: "/",
//       },
//     ]);
//   }, [id]);
//   const columns: IColumns[] = [
//     {
//       header: "Order ID",
//       fieldName: "",
//       type: "default",
//       // sortable: true
//     },
//     {
//       header: "Status",
//       fieldName: "status",
//       type: "status",
//     },
//     {
//       header: "Customer",
//       fieldName: "price",
//       type: "default",
//     },
//     {
//       header: "Customer Address",
//       fieldName: "mode",
//       type: "default",
//     },
//     {
//       header: "Order Time & Date",
//       fieldName: "status",
//       type: "status",
//     },
//     {
//       header: "Delivery Time & Date",
//       fieldName: "status",
//       type: "status",
//     },

//     {
//       header: "Actions",
//       fieldName: "actions",
//       type: "action",
//       actions: ["Edit"].filter(Boolean),
//       // actionCallback: (action, row) => handleAction(action, row),
//       // hideSelectedActions: {
//       //     fieldToHide: [
//       //         {
//       //             field: 'status',
//       //             hideValue: ['Incomplete'],
//       //             hideActions: ['Edit']
//       //         },
//       //         // {
//       //         //     field: 'profileStatus',
//       //         //     hideValue: ['Approved'],
//       //         //     hideActions: ['Approve']
//       //         // }
//       //     ]
//       // }
//     },
//   ];

//   const handleOrders = () => {
//     {
//       const form: any = (
//         <AssignOrderDrawer
//           id="assignOrderAdd"
//           control={control}
//           register={register}
//           reset={reset}
//           setValue={setValue}
//           onCancel={() => {
//             reset();
//             setOpen(false);
//             setFormComponent(null);
//           }}
//         />
//       );
//       setFormComponent(form);
//       setTimeout(() => {
//         setOpen(true);
//       }, 10);
//     }
//   };
//   return (
//     <>
//       <WSBackButton id="btnScheduleBack" url={"/technician-management/list"} />

//       <Paper
//         elevation={0}
//         style={{
//           paddingLeft: 20,
//           paddingRight: 20,
//           marginTop: 30,
//           paddingBottom: 25,
//           borderRadius: "8px",
//         }}
//       >
//         <Grid
//           container
//           justifyContent="space-between"
//           alignItems="center"
//           p={3}
//         >
//           <Grid>
//             <Typography variant="h6" fontWeight={600}>
//               David Miller
//             </Typography>

//             <Stack direction="column" spacing={0.5} mt={1}>
//               <Chip
//                 label="+2 Certified"
//                 size="small"
//                 sx={{ backgroundColor: "#ECF2FF", color: "#2B52DE" }}
//               />
//               <Typography variant="body2" color="text.secondary">
//                 3 Years Exp | ID: PHB1023
//               </Typography>
//             </Stack>
//           </Grid>

//           <Chip
//             label="Call"
//             icon={<WSIcons.IoCall style={{ color: "#098963" }} />}
//             size="small"
//             sx={{ ml: 2, color: "#098963", backgroundColor: "#CEEEE5" }}
//           />
//         </Grid>
//         <Divider />
//         <Grid container spacing={2} p={3}>
//           <Grid item xs={12}>
//             <Typography>
//               <WSIcons.IoLocationOutline style={{ color: "#022219" }} /> Live
//               Location
//             </Typography>
//           </Grid>

//           <Grid item xs={12} sm={1}>
//             <Typography variant="body2" color={"GrayText"}>
//               Order ID
//             </Typography>
//           </Grid>
//           <Grid item xs={12} sm={11}>
//             <Typography variant="body2" color={"GrayText"}>
//               Z : #ORD1095
//             </Typography>
//             <Typography variant="body2" color={"GrayText"}>
//               Sarah Jenkins
//             </Typography>
//             <Typography variant="body2" color={"GrayText"}>
//               Burger St, near Police Station, Fort Nagar, Kannur, 66666{" "}
//             </Typography>
//           </Grid>
//           <Grid item xs={12} sm={1}>
//             <Typography variant="body2" color={"GrayText"}>
//               <WSIcons.CiLocationArrow1 /> Location
//             </Typography>
//           </Grid>
//           <Grid item xs={12} sm={10}>
//             <Typography variant="body2" color={"GrayText"}>
//               : Arogya Pharma, Edakkaad, Hill Nagar, Kannur, 66663{" "}
//               <span color="black">TO</span> Burger St, near Police Station, Fort
//               Nagar, Kannur, 66666
//             </Typography>
//           </Grid>
//           <Grid item xs={12}>
//             <LiveLocationTracker apiUrl="http://api.open-notify.org/iss-now.json" />
//           </Grid>
//           <Grid item xs={12}>
//             <Typography style={{ color: "#2B4CBA" }}>
//               Assigned : 10:45 AM
//             </Typography>
//           </Grid>
//           {/*Displays only when order is above 3 */}
//           <Grid item xs={12}>
//             <Button
//               size="small"
//               variant="outlined"
//               fullWidth
//               sx={{ color: "#098963", borderRadius: 8 }}
//               onClick={handleOrders}
//             >
//               <WSIcons.CiDeliveryTruck fontSize={32} /> 3+ Orders{" "}
//               <WSIcons.ArrowRight />
//             </Button>
//           </Grid>
//           <Grid item xs={12}>
//             <Typography sx={{ color: "#022219", fontWeight: 500 }}>
//               Performance overview
//             </Typography>
//           </Grid>
//           <Grid container spacing={2} mt={3}>
//             {[
//               { label: "Completion Order (Today)", value: "98%" },
//               { label: " Completion Order (Total)", value: "94%" },
//               { label: "Avg Time", value: "28m" },
//             ].map((item) => (
//               <Grid item xs={12} md={4} key={item.label}>
//                 <Paper
//                   elevation={0}
//                   sx={{
//                     p: 2,
//                     textAlign: "center",
//                     borderRadius: 2,
//                     backgroundColor: "#ECF2FF",
//                   }}
//                 >
//                   <Typography
//                     fontSize={24}
//                     fontWeight={400}
//                     sx={{ color: "#022219" }}
//                   >
//                     {" "}
//                     {item.value}
//                   </Typography>
//                   <Typography color="text.secondary">{item.label}</Typography>
//                 </Paper>
//               </Grid>
//             ))}
//           </Grid>
//         </Grid>
//         <Grid container spacing={2}>
//           <Grid item xs={12}>
//             <Typography sx={{ color: "#022219", fontWeight: 500, mb: 5 }}>
//               Recent History
//             </Typography>
//             <WSDataGridNew
//               columns={columns}
//               id="technicianListGrid"
//               title=""
//               //   exportCsv={true}
//               gridHeaderSx={{
//                 backgroundColor: "whitesmoke",
//                 border: "1px solid whitesmoke",
//               }}
//             />
//           </Grid>
//         </Grid>
//       </Paper>
//       <Paper
//         elevation={0}
//         style={{
//           paddingLeft: 20,
//           paddingRight: 20,
//           marginTop: 20,
//           paddingBottom: 25,
//           borderRadius: "8px",
//         }}
//       >
//         <Grid container spacing={2}>
//           <Grid item xs={12} sm={10}>
//             <WSImageUpload
//               control={control}
//               id="image"
//               name="image"
//               label=""
//               rules={{ required: false }}
//             />
//           </Grid>
//           <Grid item xs={12} sm={2}>
//             <WSButton
//               id="edit"
//               type="button"
//               label="Edit"
//               size="medium"
//               variant="outlined"
//               startIcon={<WSIcons.FaRegEdit />}
//               color="primary"
//               sx={{
//                 borderRadius: 8,
//                 width: "8rem",
//                 border: "1px solid #098963",
//                 color: "#098963",
//                 // backgroundColor: "#FFFFFF",
//               }}
//             />
//           </Grid>

//           {/* PERSONAL DETAILS BOX */}
//           <Grid item xs={12}>
//             <Typography sx={{ color: "#022219", fontWeight: 600, mb: 2 }}>
//               Personal Details
//             </Typography>
//             <Grid
//               sx={{
//                 p: 3,
//                 borderRadius: 2,
//                 border: "1px solid #E0E0E0",
//                 backgroundColor: "#FAFAFA",
//                 mt: 3,
//               }}
//             >
//               <Grid container spacing={2}>
//                 {/* Phone */}
//                 <Grid item xs={12} sm={10}>
//                   <Typography variant="body2" color="GrayText">
//                     Phone Number
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={2}>
//                   <Typography variant="body2" color="text.primary">
//                     : +91 98765-43210
//                   </Typography>
//                 </Grid>

//                 {/* DOB */}
//                 <Grid item xs={12} sm={10}>
//                   <Typography variant="body2" color="GrayText">
//                     Date Of Birth
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={2}>
//                   <Typography variant="body2" color="text.primary">
//                     : 12 Jan, 2000
//                   </Typography>
//                 </Grid>

//                 {/* Address */}
//                 <Grid item xs={12} sm={10}>
//                   <Typography variant="body2" color="GrayText">
//                     Address
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={2}>
//                   <Typography variant="body2" color="text.primary">
//                     : Rockstar Villa, Kannur Po Kannur, 987654
//                   </Typography>
//                 </Grid>

//                 {/* Qualification */}
//                 <Grid item xs={12} sm={10}>
//                   <Typography variant="body2" color="GrayText">
//                     Qualification
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={2}>
//                   <Typography variant="body2" color="text.primary">
//                     : DMLT
//                   </Typography>
//                 </Grid>
//               </Grid>
//             </Grid>
//           </Grid>

//           <Grid item xs={12}>
//             <Typography sx={{ color: "#022219", fontWeight: 600, mb: 2 }}>
//               Documents & Verifications
//             </Typography>
//             <Grid
//               sx={{
//                 p: 3,
//                 borderRadius: 2,
//                 border: "1px solid #E0E0E0",
//                 backgroundColor: "#FAFAFA",
//                 mt: 3,
//               }}
//             >
//               <Grid container spacing={2}>
//                 {/* Phone */}
//                 <Grid item xs={12} sm={10}>
//                   <Typography variant="body2" color="GrayText">
//                     Aadhar
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={2}>
//                   <Typography variant="body2" sx={{ color: "#098963" }}>
//                     Verified
//                   </Typography>
//                 </Grid>

//                 {/* DOB */}
//                 <Grid item xs={12} sm={10}>
//                   <Typography variant="body2" color="GrayText">
//                     License
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={2}>
//                   <Typography variant="body2" sx={{ color: "#098963" }}>
//                     Verified
//                   </Typography>
//                 </Grid>

//                 {/* Address */}
//                 <Grid item xs={12} sm={10}>
//                   <Typography variant="body2" color="GrayText">
//                     Certification
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={2}>
//                   <Typography variant="body2" sx={{ color: "#098963" }}>
//                     Verified
//                   </Typography>
//                 </Grid>

//                 {/* Qualification */}
//                 <Grid item xs={12} sm={10}>
//                   <Typography variant="body2" color="GrayText">
//                     Police Verification
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={2}>
//                   <Typography variant="body2" sx={{ color: "#098963" }}>
//                     Verified
//                   </Typography>
//                 </Grid>
//               </Grid>
//             </Grid>
//           </Grid>
//         </Grid>
//         <SwipeableDrawerForm
//           anchor="right"
//           title={"Assign Orders"}
//           openForm={open}
//           formComponent={
//             <form onSubmit={handleSubmit(handleOrders)}>{formComponent}</form>
//           }
//           onClose={() => {
//             reset();
//             setOpen(false);
//             setFormComponent(null);
//           }}
//         />
//       </Paper>
//     </>
//   );
// });








// import {
//   Button,
//   Chip,
//   Divider,
//   Grid,
//   Paper,
//   Stack,
//   Typography,
// } from "@mui/material";
// import React, { useEffect, useState, useCallback } from "react";
// import { useParams } from "react-router-dom";
// import { WSIcons } from "../../../commonFunctions/iIcons";
// import WSDataGridNew, {
//   IColumns,
// } from "../../../Components/DataGrid/WSDataGridNew";
// import WSImageUpload from "../../../Components/FileUpload/WSImageUpload";
// import { useForm } from "react-hook-form";
// import WSButton from "../../../Components/Button/WSButton";
// import LiveLocationTracker from "../../../Components/MapView/MapView";
// import SwipeableDrawerForm from "../../../Components/DrawyerForm/DrawyerForm";
// import AssignOrderDrawer from "./AssignDrawer";
// import TechnicianDrawer from "./TechnicianDrawer"; // ✅ NEW IMPORT
// import WSBackButton from "../../../Components/BackButton/BackButton";
// import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
// import { callAPI, Method } from "../../../commonFunctions/CommonFunctions";

// interface DeliveryPersonData {
//   id: string;
//   name: string;
//   phoneNumber: string;
//   fullAddress: string | null;
//   dateOfBirth: string | null;
//   qualification: string | null;
//   experience: number;
//   workingHours: string | null;
//   profileImageUrl: string;
//   isAadharVerified: boolean;
//   isLicenseVerified: boolean;
//   isCertificationVerified: boolean;
//   isPoliceVerified: boolean;
//   isActive: boolean;
//   vendorId: string;
//   createdAt: string;
//   updatedAt: string | null;
// }

// interface RecentHistory {
//   orderId: string;
//   status: string;
//   customer: string;
//   customerAddress: string;
//   orderTime: string;
//   deliverytime: string;
// }

// interface DashboardData {
//   assignedTime: string | null;
//   deliveryPerson: DeliveryPersonData;
//   todayCompletionPercentage: number;
//   totalCompletionPercentage: number;
//   ongoing: any | null;
//   next: any[];
//   recentHistory: RecentHistory[];
// }

// interface ApiResponse {
//   status: boolean;
//   message: string;
//   data: DashboardData;
// }

// export const TechnicianDetails: React.FC<any> = React.memo((props) => {
//   const { control, setValue, reset, register, handleSubmit } = useForm();
//   const [open, setOpen] = React.useState(false);
//   const [editDrawerOpen, setEditDrawerOpen] = React.useState(false); // ✅ NEW STATE
//   const [formComponent, setFormComponent] = useState<any>();
//   const [dashboardData, setDashboardData] = useState<DashboardData | null>(null);
//   const [loading, setLoading] = useState<boolean>(true);

//   const params = useParams<{ id: string }>();
//   const id = params?.id;

//   const fetchTechnicianData = useCallback(async () => {
//     if (!id) {
//       console.error("❌ No technician ID");
//       setLoading(false);
//       return;
//     }

//     try {
//       setLoading(true);
//       const response: ApiResponse = await callAPI(
//         `pharmacy/DeliveryPerson/DeliveryPerson/${id}/dashboard`,
//         Method.GET
//       );

//       console.log("✅ API Response:", response);

//       if (response.status && response.data) {
//         setDashboardData(response.data);
//         const deliveryPerson = response.data.deliveryPerson;
//         setValue("name", deliveryPerson.name);
//         setValue("phoneNumber", deliveryPerson.phoneNumber);
//       }
//     } catch (error) {
//       console.error("💥 Error:", error);
//     } finally {
//       setLoading(false);
//     }
//   }, [id, setValue]);

//   useEffect(() => {
//     fetchTechnicianData();
//   }, [fetchTechnicianData]);

//   const technicianName = dashboardData?.deliveryPerson?.name || "David Miller";
  
//   useEffect(() => {
//     breadCrumbsStore.updateBreadCrumbs([
//       { "Technician Management": "technician-management/list" },
//       { technicianName: "" },
//     ]);
//   }, [technicianName]);

//   const columns: IColumns[] = [
//     { header: "Order ID", fieldName: "orderId", type: "default" },
//     { header: "Status", fieldName: "status", type: "status" },
//     { header: "Customer", fieldName: "customer", type: "default" },
//     { header: "Customer Address", fieldName: "customerAddress", type: "default" },
//     { header: "Order Time & Date", fieldName: "orderTime", type: "date" },
//     { header: "Delivery Time & Date", fieldName: "deliverytime", type: "date" },
//     // {
//     //   header: "Actions",
//     //   fieldName: "actions",
//     //   type: "action",
//     //   actions: ["Edit"].filter(Boolean),
//     // },
//   ];

//   const handleOrders = () => {
//     const form: any = (
//       <AssignOrderDrawer
//         id="assignOrderAdd"
//         control={control}
//         register={register}
//         reset={reset}
//         setValue={setValue}
//         deliveryPersonId={id!}
//         onCancel={() => {
//           reset();
//           setOpen(false);
//           setFormComponent(null);
//         }}
//       />
//     );
//     setFormComponent(form);
//     setTimeout(() => setOpen(true), 10);
//   };

//   // ✅ NEW: Handle Edit Button Click
//   const handleEditProfile = () => {
//     if (dashboardData?.deliveryPerson?.id) {
//       setEditDrawerOpen(true);
//     }
//   };

//   if (loading) {
//     return (
//       <>
//         <WSBackButton id="btnScheduleBack" url="/technician-management/list" />
//         <Paper style={{ padding: 20, marginTop: 30, borderRadius: "8px" }}>
//           <Typography>Loading technician dashboard...</Typography>
//         </Paper>
//       </>
//     );
//   }

//   if (!dashboardData) {
//     return (
//       <>
//         <WSBackButton id="btnScheduleBack" url="/technician-management/list" />
//         <Paper style={{ padding: 20, marginTop: 30, borderRadius: "8px" }}>
//           <Typography color="error">Technician not found</Typography>
//         </Paper>
//       </>
//     );
//   }

//   const deliveryPerson = dashboardData.deliveryPerson;
//   const recentHistory = dashboardData.recentHistory || [];

//   return (
//     <>
//       <WSBackButton id="btnScheduleBack" url={"/technician-management/list"} />

//       {/* MAIN DASHBOARD PAPER */}
//       <Paper
//         elevation={0}
//         style={{
//           paddingLeft: 20,
//           paddingRight: 20,
//           marginTop: 30,
//           paddingBottom: 25,
//           borderRadius: "8px",
//         }}
//       >
//         <Grid container justifyContent="space-between" alignItems="center" p={3}>
//           <Grid>
//             <Typography variant="h6" fontWeight={600}>
//               {deliveryPerson.name}
//             </Typography>
//             <Stack direction="column" spacing={0.5} mt={1}>
//               <Chip
//                 label={`+${deliveryPerson.experience} Certified`}
//                 size="small"
//                 sx={{ backgroundColor: "#ECF2FF", color: "#2B52DE" }}
//               />
//               <Typography variant="body2" color="text.secondary">
//                 {deliveryPerson.experience} Years Exp | {deliveryPerson.id}
//               </Typography>
//             </Stack>
//           </Grid>

//           <Chip
//             label="Call"
//             icon={<WSIcons.IoCall style={{ color: "#098963" }} />}
//             size="small"
//             sx={{ 
//               ml: 2, 
//               color: "#098963", 
//               backgroundColor: "#CEEEE5",
//               cursor: "pointer"
//             }}
//             onClick={() => window.open(`tel:${deliveryPerson.phoneNumber}`)}
//           />
//         </Grid>
//         <Divider />
//         <Grid container spacing={2} p={3}>
//           <Grid item xs={12}>
//             <Typography>
//               <WSIcons.IoLocationOutline style={{ color: "#022219" }} /> Live Location
//             </Typography>
//           </Grid>

//           {recentHistory.length > 0 && (
//             <>
//               <Grid item xs={12} sm={1}>
//                 <Typography variant="body2" color="GrayText">
//                   Order ID
//                 </Typography>
//               </Grid>
//               <Grid item xs={12} sm={11}>
//                 <Typography variant="body2" color="GrayText">
//                   Z : #{recentHistory[0].orderId}
//                 </Typography>
//                 <Typography variant="body2" color="GrayText">
//                   {recentHistory[0].customer}
//                 </Typography>
//                 <Typography variant="body2" color="GrayText">
//                   {recentHistory[0].customerAddress}
//                 </Typography>
//               </Grid>
//             </>
//           )}

//           <Grid item xs={12} sm={1}>
//             <Typography variant="body2" color="GrayText">
//               <WSIcons.CiLocationArrow1 /> Location
//             </Typography>
//           </Grid>
//           <Grid item xs={12} sm={10}>
//             <Typography variant="body2" color="GrayText">
//               : Arogya Pharma, Edakkaad, Hill Nagar, Kannur, 66663{" "}
//               <span style={{ color: "black" }}>TO</span> {deliveryPerson.fullAddress}
//             </Typography>
//           </Grid>

//           <Grid item xs={12}>
//             <LiveLocationTracker apiUrl="http://api.open-notify.org/iss-now.json" />
//           </Grid>

//           <Grid item xs={12}>
//             <Typography style={{ color: "#2B4CBA" }}>
//               Assigned : {dashboardData.assignedTime || "10:45 AM"}
//             </Typography>
//           </Grid>

//           <Grid item xs={12}>
//             <Button
//               size="small"
//               variant="outlined"
//               fullWidth
//               sx={{ color: "#098963", borderRadius: 8 }}
//               onClick={handleOrders}
//             >
//               <WSIcons.CiDeliveryTruck style={{ fontSize: 32, marginRight: 8 }} /> 
//               {recentHistory.length || 0}+ Orders{" "}
//               <WSIcons.ArrowRight style={{ marginLeft: 8 }} />
//             </Button>
//           </Grid>

//           <Grid item xs={12}>
//             <Typography sx={{ color: "#022219", fontWeight: 500 }}>
//               Performance overview
//             </Typography>
//           </Grid>
//           <Grid container spacing={2} mt={3}>
//             {[
//               { label: "Completion Order (Today)", value: `${dashboardData.todayCompletionPercentage}%` },
//               { label: "Completion Order (Total)", value: `${dashboardData.totalCompletionPercentage}%` },
//               { label: "Avg Time", value: "28m" },
//             ].map((item) => (
//               <Grid item xs={12} md={4} key={item.label}>
//                 <Paper
//                   elevation={0}
//                   sx={{
//                     p: 2,
//                     textAlign: "center",
//                     borderRadius: 2,
//                     backgroundColor: "#ECF2FF",
//                   }}
//                 >
//                   <Typography
//                     fontSize={24}
//                     fontWeight={400}
//                     sx={{ color: "#022219" }}
//                   >
//                     {item.value}
//                   </Typography>
//                   <Typography color="text.secondary">{item.label}</Typography>
//                 </Paper>
//               </Grid>
//             ))}
//           </Grid>
//         </Grid>
//         <Grid container spacing={2}>
//           <Grid item xs={12}>
//             <Typography sx={{ color: "#022219", fontWeight: 500, mb: 5 }}>
//               Recent History
//             </Typography>
//             <WSDataGridNew
//               columns={columns}
//               data={recentHistory}
//               id="technicianListGrid"
//               title=""
//               gridHeaderSx={{
//                 backgroundColor: "whitesmoke",
//                 border: "1px solid whitesmoke",
//               }}
//             />
//           </Grid>
//         </Grid>
//       </Paper>

//       {/* PERSONAL DETAILS PAPER */}
//       <Paper
//         elevation={0}
//         style={{
//           paddingLeft: 20,
//           paddingRight: 20,
//           marginTop: 20,
//           paddingBottom: 25,
//           borderRadius: "8px",
//         }}
//       >
//         <Grid container spacing={2}>
//           {/* ✅ FIXED: Edit Button with onClick */}
//           <Grid item xs={12} sm={10}>
//             <WSImageUpload
//               control={control}
//               id="image"
//               name="image"
//               label=""
//               rules={{ required: false }}
//               imgUrl={deliveryPerson.profileImageUrl}
//             />
//           </Grid>
//           <Grid item xs={12} sm={2}>
//             <WSButton
//               id="edit"
//               type="button"
//               label="Edit"
//               size="medium"
//               variant="outlined"
//               startIcon={<WSIcons.FaRegEdit />}
//               color="primary"
//               sx={{
//                 borderRadius: 8,
//                 width: "8rem",
//                 border: "1px solid #098963",
//                 color: "#098963",
//               }}
//               onClick={handleEditProfile} // ✅ ADDED onClick
//             />
//           </Grid>

//           {/* PERSONAL DETAILS BOX */}
//           <Grid item xs={12}>
//             <Typography sx={{ color: "#022219", fontWeight: 600, mb: 2 }}>
//               Personal Details
//             </Typography>
//             <Grid
//               sx={{
//                 p: 3,
//                 borderRadius: 2,
//                 border: "1px solid #E0E0E0",
//                 backgroundColor: "#FAFAFA",
//                 mt: 3,
//               }}
//             >
//               <Grid container spacing={2}>
//                 <Grid item xs={12} sm={10}>
//                   <Typography variant="body2" color="GrayText">
//                     Phone Number
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={2}>
//                   <Typography variant="body2" color="text.primary">
//                     : {deliveryPerson.phoneNumber}
//                   </Typography>
//                 </Grid>

//                 <Grid item xs={12} sm={10}>
//                   <Typography variant="body2" color="GrayText">
//                     Date Of Birth
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={2}>
//                   <Typography variant="body2" color="text.primary">
//                     : {deliveryPerson.dateOfBirth }
//                   </Typography>
//                 </Grid>

//                 <Grid item xs={12} sm={10}>
//                   <Typography variant="body2" color="GrayText">
//                     Address
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={2}>
//                   <Typography variant="body2" color="text.primary">
//                     : {deliveryPerson.fullAddress || "Rockstar Villa, Kannur Po Kannur, 987654"}
//                   </Typography>
//                 </Grid>

//                 <Grid item xs={12} sm={10}>
//                   <Typography variant="body2" color="GrayText">
//                     Qualification
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={2}>
//                   <Typography variant="body2" color="text.primary">
//                     : {deliveryPerson.qualification || "DMLT"}
//                   </Typography>
//                 </Grid>
//               </Grid>
//             </Grid>
//           </Grid>

//           <Grid item xs={12}>
//             <Typography sx={{ color: "#022219", fontWeight: 600, mb: 2 }}>
//               Documents & Verifications
//             </Typography>
//             <Grid
//               sx={{
//                 p: 3,
//                 borderRadius: 2,
//                 border: "1px solid #E0E0E0",
//                 backgroundColor: "#FAFAFA",
//                 mt: 3,
//               }}
//             >
//               <Grid container spacing={2}>
//                 <Grid item xs={12} sm={10}>
//                   <Typography variant="body2" color="GrayText">
//                     Aadhar
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={2}>
//                   <Typography variant="body2" sx={{ color: deliveryPerson.isAadharVerified ? "#098963" : "#FF6B6B" }}>
//                     {deliveryPerson.isAadharVerified ? "Verified" : "Pending"}
//                   </Typography>
//                 </Grid>

//                 <Grid item xs={12} sm={10}>
//                   <Typography variant="body2" color="GrayText">
//                     License
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={2}>
//                   <Typography variant="body2" sx={{ color: deliveryPerson.isLicenseVerified ? "#098963" : "#FF6B6B" }}>
//                     {deliveryPerson.isLicenseVerified ? "Verified" : "Pending"}
//                   </Typography>
//                 </Grid>

//                 <Grid item xs={12} sm={10}>
//                   <Typography variant="body2" color="GrayText">
//                     Certification
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={2}>
//                   <Typography variant="body2" sx={{ color: deliveryPerson.isCertificationVerified ? "#098963" : "#FF6B6B" }}>
//                     {deliveryPerson.isCertificationVerified ? "Verified" : "Pending"}
//                   </Typography>
//                 </Grid>

//                 <Grid item xs={12} sm={10}>
//                   <Typography variant="body2" color="GrayText">
//                     Police Verification
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12} sm={2}>
//                   <Typography variant="body2" sx={{ color: deliveryPerson.isPoliceVerified ? "#098963" : "#FF6B6B" }}>
//                     {deliveryPerson.isPoliceVerified ? "Verified" : "Pending"}
//                   </Typography>
//                 </Grid>
//               </Grid>
//             </Grid>
//           </Grid>
//         </Grid>

//         {/* ✅ ASSIGN ORDERS DRAWER */}
//         <SwipeableDrawerForm
//           anchor="right"
//           title={"Assign Orders"}
//           openForm={open}
//           formComponent={<form>{formComponent}</form>}
//           onClose={() => {
//             reset();
//             setOpen(false);
//             setFormComponent(null);
//           }}
//         />

//         {/* ✅ NEW: EDIT TECHNICIAN DRAWER */}
       
// {/* <SwipeableDrawerForm
//   anchor="right"
//   title="Edit Technician Profile"
//   openForm={editDrawerOpen}
//   id={`technicianEdit-${deliveryPerson.id}`}  // ✅ Already good
//   isEdit={true}  // ✅ ADD THIS - Makes button show "Update"
//   formComponent={
//     <TechnicianDrawer
//       id={`technicianEdit-${deliveryPerson.id}`}
//       control={control}
//       register={register}
//       reset={reset}
//       setValue={setValue}
//       onCancel={() => {
//         setEditDrawerOpen(false);
//         reset();
//       }}
//       onSuccess={() => {
//         setEditDrawerOpen(false);
//         fetchTechnicianData(); // Refresh data
//       }}
//     />
//   }
//   onClose={() => {
//     setEditDrawerOpen(false);
//     reset();
//   }}
// /> */}



// {/* ✅ FIXED: EDIT TECHNICIAN DRAWER */}
// {/* 🔥 FIXED EDIT DRAWER */}
// {/* 🔥 FIXED: Edit Technician Drawer */}
// <SwipeableDrawerForm
//   anchor="right"
//   title="Edit Technician Profile"
//   openForm={editDrawerOpen}
//   id={`technicianEdit-${deliveryPerson.id}`}
//   isEdit={true}
//   formComponent={
//     <TechnicianDrawer
//       key={`edit-drawer-${editDrawerOpen}-${deliveryPerson.id}`} // ✅ Forces re-mount
//       id={`technicianEdit-${deliveryPerson.id}`}
//       control={control}
//       register={register}
//       reset={reset}
//       setValue={setValue}
//       onCancel={() => {
//         setEditDrawerOpen(false);
//         reset({
//           Name: "",
//           PhoneNumber: "",
//           FullAddress: "",
//           DateOfBirth: "",
//           Qualification: "",
//           Experience: "",
//           WorkingHours: "",
//           "Documents.0": "no",
//           "Documents.1": "no",
//           "Documents.2": "no",
//           "Documents.3": "no",
//         });
//       }}
//       onSuccess={() => {
//         setEditDrawerOpen(false);
//         fetchTechnicianData();
//          window.location.reload(); 
//       }}
//     />
//   }
//   onClose={() => {
//     setEditDrawerOpen(false);
//     reset({
//       Name: "",
//       PhoneNumber: "",
//       FullAddress: "",
//       DateOfBirth: "",
//       Qualification: "",
//       Experience: "",
//       WorkingHours: "",
//       "Documents.0": "no",
//       "Documents.1": "no",
//       "Documents.2": "no",
//       "Documents.3": "no",
//     });
//   }}
// />




//       </Paper>
//     </>
//   );
// });





import {
  Avatar,
  Button,
  Chip,
  Divider,
  Grid,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import React, { useEffect, useState, useCallback } from "react";
import { useParams } from "react-router-dom";
import { WSIcons } from "../../../commonFunctions/iIcons";
import WSDataGridNew, {
  IColumns,
} from "../../../Components/DataGrid/WSDataGridNew";
import WSImageUpload from "../../../Components/FileUpload/WSImageUpload";
import { useForm } from "react-hook-form";
import WSButton from "../../../Components/Button/WSButton";
import LiveLocationTracker from "../../../Components/MapView/MapView";
import SwipeableDrawerForm from "../../../Components/DrawyerForm/DrawyerForm";
import AssignOrderDrawer from "./AssignDrawer";
import TechnicianDrawer from "./TechnicianDrawer";
import WSBackButton from "../../../Components/BackButton/BackButton";
import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
import { callAPI, Method } from "../../../commonFunctions/CommonFunctions";

import configData from "../../../Config/config.json";

// Add after imports
const imgUrl = configData.imgUrl;
const getCorrectedImageUrl = (imageUrl: string) => {
  return imageUrl?.replace(/^UploadedImages\//, '') || '';
};


interface DeliveryPersonData {
  id: string;
  name: string;
  phoneNumber: string;
  fullAddress: string | null;
  dateOfBirth: string | null;
  qualification: string | null;
  experience: number;
  workingHours: string | null;
  profileImageUrl: string;
  isAadharVerified: boolean;
  isLicenseVerified: boolean;
  isCertificationVerified: boolean;
  isPoliceVerified: boolean;
  isActive: boolean;
  vendorId: string;
  vendor: null;
  createdAt: string;
  updatedAt: string | null;
  documents: any[];
}

interface RecentHistory {
  orderId: string;
  status: string;
  customer: string;
  customerAddress: string;
  orderTime: string;
  deliverytime: string;
}

interface MapLocation {
  latitude: string;
  longitude: string;
}

interface DashboardData {
  assignedTime: string | null;
  deliveryPerson: DeliveryPersonData;
  todayCompletionPercentage: number;
  totalCompletionPercentage: number;
  mapLocation: MapLocation;
  ongoing: any | null;
  next: any[];
  recentHistory: RecentHistory[];
  avgDeliveryMinutes: string | null;

}

interface ApiResponse {
  status: boolean;
  message: string;
  data: DashboardData;
}

export const TechnicianDetails: React.FC<any> = React.memo((props) => {
  const { control, setValue, reset, register, handleSubmit } = useForm();
  const [open, setOpen] = React.useState(false);
  const [editDrawerOpen, setEditDrawerOpen] = React.useState(false);
  const [formComponent, setFormComponent] = useState<any>();
  const [dashboardData, setDashboardData] = useState<DashboardData | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  const params = useParams<{ id: string }>();
  const id = params?.id;

  const getImageUrl = (imageUrl: string) => {
  if (!imageUrl) return '/default-avatar.png';
  return imageUrl.startsWith('http') 
    ? imageUrl 
    : `${imgUrl}/${getCorrectedImageUrl(imageUrl)}`;
};

  const fetchTechnicianData = useCallback(async () => {
    if (!id) {
      console.error("❌ No technician ID");
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      const response: ApiResponse = await callAPI(
        `pharmacy/DeliveryPerson/DeliveryPerson/${id}/dashboard`,
        Method.GET
      );

      console.log("✅ API Response:", response);

      if (response.status && response.data) {
        setDashboardData(response.data);
        const deliveryPerson = response.data.deliveryPerson;
        setValue("name", deliveryPerson.name);
        setValue("phoneNumber", deliveryPerson.phoneNumber);
      }
    } catch (error) {
      console.error("💥 Error:", error);
    } finally {
      setLoading(false);
    }
  }, [id, setValue]);

  useEffect(() => {
    fetchTechnicianData();
  }, [fetchTechnicianData]);

  const technicianName = dashboardData?.deliveryPerson?.name || "David Miller";
  
  useEffect(() => {
    breadCrumbsStore.updateBreadCrumbs([
      { "Technician Management": "technician-management/list" },
      { technicianName: "" },
    ]);
  }, [technicianName]);

  const columns: IColumns[] = [
    { header: "Order ID", fieldName: "orderId", type: "default" },
    { header: "Status", fieldName: "status", type: "status" },
    { header: "Customer", fieldName: "customer", type: "default" },
    { header: "Customer Address", fieldName: "customerAddress", type: "default" },
    { header: "Order Time & Date", fieldName: "orderTime", type: "date" },
    { header: "Delivery Time & Date", fieldName: "deliverytime", type: "date" },
  ];

  const handleOrders = () => {
    const form: any = (
      <AssignOrderDrawer
        id="assignOrderAdd"
        control={control}
        register={register}
        reset={reset}
        setValue={setValue}
        deliveryPersonId={id!}
        onCancel={() => {
          reset();
          setOpen(false);
          setFormComponent(null);
        }}
      />
    );
    setFormComponent(form);
    setTimeout(() => setOpen(true), 10);
  };

  const handleEditProfile = () => {
    if (dashboardData?.deliveryPerson?.id) {
      setEditDrawerOpen(true);
    }
  };

  if (loading) {
    return (
      <>
        <WSBackButton id="btnScheduleBack" url="/technician-management/list" />
        <Paper style={{ padding: 20, marginTop: 30, borderRadius: "8px" }}>
          <Typography>Loading technician dashboard...</Typography>
        </Paper>
      </>
    );
  }

  if (!dashboardData) {
    return (
      <>
        <WSBackButton id="btnScheduleBack" url="/technician-management/list" />
        <Paper style={{ padding: 20, marginTop: 30, borderRadius: "8px" }}>
          <Typography color="error">Technician not found</Typography>
        </Paper>
      </>
    );
  }

  const deliveryPerson = dashboardData.deliveryPerson;
  const recentHistory = dashboardData.recentHistory || [];

  return (
    <>
      <WSBackButton id="btnScheduleBack" url={"/technician-management/list"} />

      {/* MAIN DASHBOARD PAPER */}
      <Paper
  elevation={0}
  style={{
    paddingLeft: 20,
    paddingRight: 20,
    marginTop: 30,
    paddingBottom: 25,
    borderRadius: "8px",
  }}
>
  <Grid container justifyContent="space-between" alignItems="center" p={3}>
    <Grid item sx={{ display: "flex", alignItems: "center", gap: 2 }}>
      {/* ✅ Profile image using EXACT ProductDetails method */}
      <Avatar
        src={getImageUrl(deliveryPerson.profileImageUrl)}  
        sx={{ 
          width: 64, 
          height: 64,
          backgroundColor: "#ECF2FF"
        }}
      />

      <div>
        <Typography variant="h6" fontWeight={600}>
          {deliveryPerson.name} {/* ✅ Matches your data structure */}
        </Typography>
        <Stack direction="column" spacing={0.5} mt={1}>
          <Chip
            label={`+${deliveryPerson.experience} Certified`}
            size="small"
            sx={{ backgroundColor: "#ECF2FF", color: "#2B52DE" }}
          />
          <Typography variant="body2" color="text.secondary">
            {deliveryPerson.experience} Years Exp | {deliveryPerson.id}
          </Typography>
        </Stack>
      </div>
    </Grid>

          {/* <Chip
            label="Call"
            icon={<WSIcons.IoCall style={{ color: "#098963" }} />}
            size="small"
            sx={{ 
              ml: 2, 
              color: "#098963", 
              backgroundColor: "#CEEEE5",
              cursor: "pointer"
            }}
            onClick={() => window.open(`tel:${deliveryPerson.phoneNumber}`)}
          /> */}
        </Grid>
        <Divider />
        <Grid container spacing={2} p={3}>
          <Grid item xs={12}>
            <Typography>
              <WSIcons.IoLocationOutline style={{ color: "#022219" }} /> Live Location
            </Typography>
          </Grid>

          {recentHistory.length > 0 && (
            <>
              <Grid item xs={12} sm={1}>
                <Typography variant="body2" color="GrayText">
                  Order ID
                </Typography>
              </Grid>
              <Grid item xs={12} sm={11}>
                <Typography variant="body2" color="GrayText">
                  Z : #{recentHistory[0].orderId}
                </Typography>
                <Typography variant="body2" color="GrayText">
                  {recentHistory[0].customer}
                </Typography>
                <Typography variant="body2" color="GrayText">
                  {recentHistory[0].customerAddress}
                </Typography>
              </Grid>
            </>
          )}

          {/* <Grid item xs={12} sm={1}>
            <Typography variant="body2" color="GrayText">
              <WSIcons.CiLocationArrow1 /> Location
            </Typography>
          </Grid>
          <Grid item xs={12} sm={10}>
            <Typography variant="body2" color="GrayText">
              : Arogya Pharma, Edakkaad, Hill Nagar, Kannur, 66663{" "}
              <span style={{ color: "black" }}>TO</span> {deliveryPerson.fullAddress}
            </Typography>
          </Grid> */}

          {/* ✅ MAP LOCATION - USING API COORDINATES */}
          <Grid item xs={12}>
            <Typography variant="body2" color="text.secondary" gutterBottom>
              📍 Current Location: {dashboardData.mapLocation?.latitude}, {dashboardData.mapLocation?.longitude}
            </Typography>
            <LiveLocationTracker 
              latitude={dashboardData.mapLocation?.latitude} 
              longitude={dashboardData.mapLocation?.longitude}
            />
          </Grid>

          <Grid item xs={12}>
            <Typography style={{ color: "#2B4CBA" }}>
              Assigned : {dashboardData.assignedTime || "10:45 AM"}
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Button
              size="small"
              variant="outlined"
              fullWidth
              sx={{ color: "#098963", borderRadius: 8 }}
              onClick={handleOrders}
            >
              <WSIcons.CiDeliveryTruck style={{ fontSize: 32, marginRight: 8 }} /> 
              {recentHistory.length || 0}+ Orders{" "}
              <WSIcons.ArrowRight style={{ marginLeft: 8 }} />
            </Button>
          </Grid>

          <Grid item xs={12}>
            <Typography sx={{ color: "#022219", fontWeight: 500 }}>
              Performance overview
            </Typography>
          </Grid>
          <Grid container spacing={2} mt={3}>
            {[
              { label: "Completion Order (Today)", value: `${dashboardData.todayCompletionPercentage}%` },
              { label: "Completion Order (Total)", value: `${dashboardData.totalCompletionPercentage}%` },
              { label: "Avg Time", value: `${dashboardData.avgDeliveryMinutes}` },
            ].map((item) => (
              <Grid item xs={12} md={4} key={item.label}>
                <Paper
                  elevation={0}
                  sx={{
                    p: 2,
                    textAlign: "center",
                    borderRadius: 2,
                    backgroundColor: "#ECF2FF",
                  }}
                >
                  <Typography
                    fontSize={24}
                    fontWeight={400}
                    sx={{ color: "#022219" }}
                  >
                    {item.value}
                  </Typography>
                  <Typography color="text.secondary">{item.label}</Typography>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography sx={{ color: "#022219", fontWeight: 500, mb: 5 }}>
              Recent History
            </Typography>
            <WSDataGridNew
              columns={columns}
              data={recentHistory}
              id="technicianListGrid"
              title=""
              gridHeaderSx={{
                backgroundColor: "whitesmoke",
                border: "1px solid whitesmoke",
              }}
            />
          </Grid>
        </Grid>
      </Paper>

      {/* PERSONAL DETAILS PAPER */}
      <Paper
        elevation={0}
        style={{
          paddingLeft: 20,
          paddingRight: 20,
          marginTop: 20,
          paddingBottom: 25,
          borderRadius: "8px",
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm={10}>
            <WSImageUpload
              control={control}
              id="image"
              name="image"
              label=""
              rules={{ required: false }}
              imgUrl={deliveryPerson.profileImageUrl}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <WSButton
              id="edit"
              type="button"
              label="Edit"
              size="medium"
              variant="outlined"
              startIcon={<WSIcons.FaRegEdit />}
              color="primary"
              sx={{
                borderRadius: 8,
                width: "8rem",
                border: "1px solid #098963",
                color: "#098963",
              }}
              onClick={handleEditProfile}
            />
          </Grid>

          {/* PERSONAL DETAILS BOX */}
          <Grid item xs={12}>
            <Typography sx={{ color: "#022219", fontWeight: 600, mb: 2 }}>
              Personal Details
            </Typography>
            <Grid
              sx={{
                p: 3,
                borderRadius: 2,
                border: "1px solid #E0E0E0",
                backgroundColor: "#FAFAFA",
                mt: 3,
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={12} sm={10}>
                  <Typography variant="body2" color="GrayText">
                    Phone Number
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography variant="body2" color="text.primary">
                    : {deliveryPerson.phoneNumber}
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={10}>
                  <Typography variant="body2" color="GrayText">
                    Date Of Birth
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography variant="body2" color="text.primary">
                    : {deliveryPerson.dateOfBirth ? new Date(deliveryPerson.dateOfBirth).toLocaleString('en-IN', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        
      })
    : 'No date'}
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={10}>
                  <Typography variant="body2" color="GrayText">
                    Address
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography variant="body2" color="text.primary">
                    : {deliveryPerson.fullAddress || "Rockstar Villa, Kannur Po Kannur, 987654"}
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={10}>
                  <Typography variant="body2" color="GrayText">
                    Qualification
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography variant="body2" color="text.primary">
                    : {deliveryPerson.qualification || "DMLT"}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Typography sx={{ color: "#022219", fontWeight: 600, mb: 2 }}>
              Documents & Verifications
            </Typography>
            <Grid
              sx={{
                p: 3,
                borderRadius: 2,
                border: "1px solid #E0E0E0",
                backgroundColor: "#FAFAFA",
                mt: 3,
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={12} sm={10}>
                  <Typography variant="body2" color="GrayText">
                    Aadhar
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography variant="body2" sx={{ color: deliveryPerson.isAadharVerified ? "#098963" : "#FF6B6B" }}>
                    {deliveryPerson.isAadharVerified ? "Verified" : "Pending"}
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={10}>
                  <Typography variant="body2" color="GrayText">
                    License
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography variant="body2" sx={{ color: deliveryPerson.isLicenseVerified ? "#098963" : "#FF6B6B" }}>
                    {deliveryPerson.isLicenseVerified ? "Verified" : "Pending"}
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={10}>
                  <Typography variant="body2" color="GrayText">
                    Certification
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography variant="body2" sx={{ color: deliveryPerson.isCertificationVerified ? "#098963" : "#FF6B6B" }}>
                    {deliveryPerson.isCertificationVerified ? "Verified" : "Pending"}
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={10}>
                  <Typography variant="body2" color="GrayText">
                    Police Verification
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Typography variant="body2" sx={{ color: deliveryPerson.isPoliceVerified ? "#098963" : "#FF6B6B" }}>
                    {deliveryPerson.isPoliceVerified ? "Verified" : "Pending"}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* ASSIGN ORDERS DRAWER */}
        <SwipeableDrawerForm
          anchor="right"
          title={"Assign Orders"}
          openForm={open}
          formComponent={<form>{formComponent}</form>}
          onClose={() => {
            reset();
            setOpen(false);
            setFormComponent(null);
          }}
        />

        {/* EDIT TECHNICIAN DRAWER */}
        <SwipeableDrawerForm
          anchor="right"
          title="Edit Technician Profile"
          openForm={editDrawerOpen}
          id={`technicianEdit-${deliveryPerson.id}`}
          isEdit={true}
          formComponent={
            <TechnicianDrawer
              key={`edit-drawer-${editDrawerOpen}-${deliveryPerson.id}`}
              id={`technicianEdit-${deliveryPerson.id}`}
              control={control}
              register={register}
              reset={reset}
              setValue={setValue}
              onCancel={() => {
                setEditDrawerOpen(false);
                reset({
                  Name: "",
                  PhoneNumber: "",
                  FullAddress: "",
                  DateOfBirth: "",
                  Qualification: "",
                  Experience: "",
                  WorkingHours: "",
                  "Documents.0": "no",
                  "Documents.1": "no",
                  "Documents.2": "no",
                  "Documents.3": "no",
                });
              }}
              onSuccess={() => {
                setEditDrawerOpen(false);
                fetchTechnicianData();
                window.location.reload(); 
              }}
            />
          }
          onClose={() => {
            setEditDrawerOpen(false);
            reset({
              Name: "",
              PhoneNumber: "",
              FullAddress: "",
              DateOfBirth: "",
              Qualification: "",
              Experience: "",
              WorkingHours: "",
              "Documents.0": "no",
              "Documents.1": "no",
              "Documents.2": "no",
              "Documents.3": "no",
            });
          }}
        />
      </Paper>
    </>
  );
});
